export const authRoles = {
    admin: ['A'],           // Admin has access
    user: ['A','U'],        // Only Logged users
    guest: ['A','U','G'],   // Everyone has access
}
